import(/* webpackMode: "eager" */ "/app/src/app/(lyk-appp)/auth/login/page.tsx")